import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-overview",
  "use": "icon-leo-e1-overview-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-overview\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 160h320v320H160V160zm64 64v192h192V224H224z\" />\r\n  <path d=\"M544 160h320v192H544V160zm64 64v64h192V224H608z\" />\r\n  <path d=\"M544 416h320v448H544V416zm64 64v320h192V480H608z\" />\r\n  <path d=\"M160 544h320v320H160V544zm64 64v192h192V608H224z\" />\r\n  <path d=\"M288 288h64v96h-64V288zm416 320h64v128h-64V608z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-overview.svg
// module id = gdgh
// module chunks = 478